import { useEffect, useRef } from 'react';

import cs from 'classnames';

import { cn } from 'lib/helpers/utility';

import { recommendedColors } from '../lib/getColors';

const ColorPickerPanel = ({ selectedColor, panelClassName, onSelect, onClose }) => {
  // Call onClose when the panel unmounts (popover closed) to blur the trigger.
  // Held in a ref so the cleanup fires only on real unmount, not on every
  // onClose identity change from a parent re-render.
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => () => onCloseRef.current?.(), []);

  return (
    <div className={cn('w-[280px] p-4 pt-2', panelClassName)}>
      <div className="pb-2 text-xs font-600 leading-4 text-neutral-900">Colors</div>
      <div className="grid grid-cols-2 gap-2">
        {recommendedColors.map((row, rowIndex) => (
          <div key={rowIndex} className="flex gap-2">
            {row.map((recommendedColor, colIndex) => {
              const isSelected = selectedColor?.toUpperCase() === recommendedColor?.toUpperCase();
              return (
                <button
                  key={colIndex}
                  type="button"
                  className={cn(
                    'group flex size-[24px] items-center justify-center p-0',
                    isSelected ? 'cursor-default' : 'cursor-pointer'
                  )}
                  onClick={() => onSelect(recommendedColor)}>
                  <span
                    className={cs(
                      'size-[18px] rounded-full duration-150 ease-in',
                      isSelected
                        ? `border-3 border-solid border-white outline outline-2 outline-[${recommendedColor}]`
                        : 'group-hover:scale-110'
                    )}
                    style={{ background: recommendedColor, outlineColor: recommendedColor }}
                  />
                </button>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorPickerPanel;
